import React from 'react';
import styled from 'styled-components';
import { useTheme } from '../contexts/ThemeContext';
import { Moon, Sun } from 'lucide-react';

const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 16px 0;
`;

const ToggleButton = styled.button<{ isDark: boolean }>`
  position: relative;
  width: 60px;
  height: 30px;
  background: ${props => props.isDark ? '#1a1a1a' : '#e2e8f0'};
  border: none;
  border-radius: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  outline: none;
  
  &:hover {
    background: ${props => props.isDark ? '#2a2a2a' : '#cbd5e0'};
  }
  
  &:focus {
    box-shadow: 0 0 0 3px ${props => props.isDark ? 'rgba(66, 153, 225, 0.3)' : 'rgba(59, 130, 246, 0.3)'};
  }
`;

const ToggleSlider = styled.div<{ isDark: boolean }>`
  position: absolute;
  top: 2px;
  left: ${props => props.isDark ? '32px' : '2px'};
  width: 26px;
  height: 26px;
  background: white;
  border-radius: 50%;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ToggleIcon = styled.div<{ isDark: boolean }>`
  color: ${props => props.isDark ? '#666666' : '#f6ad55'};
  font-size: 14px;
  transition: all 0.3s ease;
`;

const ToggleLabel = styled.span<{ isDark: boolean }>`
  color: ${props => props.isDark ? '#d0d0d0' : '#2d3748'};
  font-size: 14px;
  font-weight: 500;
  transition: color 0.3s ease;
`;

export const ThemeToggle: React.FC = () => {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <ToggleContainer>
      <ToggleButton isDark={isDarkMode} onClick={toggleTheme}>
        <ToggleSlider isDark={isDarkMode}>
          <ToggleIcon isDark={isDarkMode}>
            {isDarkMode ? <Moon size={14} /> : <Sun size={14} />}
          </ToggleIcon>
        </ToggleSlider>
      </ToggleButton>
      <ToggleLabel isDark={isDarkMode}>
        {isDarkMode ? 'Темная тема' : 'Светлая тема'}
      </ToggleLabel>
    </ToggleContainer>
  );
};
